//เพิ่มงานวิจัย หน้าปฏิทิน
import React, { useRef, useState } from "react";
import TimePicker from "react-time-picker";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import moment from "moment";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { FontAwesome } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import ManageCalendar from "./manageCalendar";
import { apiservice, BaseUrl } from "../service/api";
import { addImage, conditionDay, conditionMonth } from "../utils";
import { useRecoilValue } from "recoil";
import { univer } from "../reducer";

const { width, height } = Dimensions.get("window");

const addResearch = ({ setpages }) => {
  const [page, setpage] = useState(0);
  const [value, onChange] = useState(new Date());
  const [modalVisible, setModalVisible] = useState(false);
  const university = useRecoilValue(univer);
  const [body, setBody] = useState({
    name: "",
    image_url: ["https://api.cquiz.app/api/image/get/user"],
    link: "",
    date: new Date(),
    starttimehour: "00",
    starttimeminute: "00",
    endtimehour: "00",
    endtimeminute: "00",
    place: "",
    description: "",
    create_by: "",
  });

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            console.log(file);
            body.append("image", file);
            // let headers = new Headers();
            // headers.append("Origin", "http://localhost:3000");
            fetch(`${BaseUrl}/image/createck`, {
              method: "post",
              body: body,
              // mode: "no-cors"
            })
              .then((res) => res.json())
              .then((res) => {
                resolve({
                  default: `${BaseUrl}/image/getimage/${res.filename.replace(
                    ".png",
                    ""
                  )}`,
                });
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
      },
    };
  }
  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  async function onPress() {
    const res = await apiservice({
      path: "/calender/create",
      method: "post",
      body: { ...body, university_id: university.id },
    });
    if (res.status == 200) {
      setpages(0);
    }
  }

  return (
    <View style={styles.container}>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
          }}
        >
          <ScrollView>
            <Text
              style={{
                width: width * 0.591,
                fontSize: 16,
                fontFamily: "Prompt-Regular",
                color: "#202020",
                marginTop: 30,
              }}
            >
              เพิ่มหัวข้อ
            </Text>

            <View
              style={{
                borderWidth: 0.591,
                borderColor: "#002377",
                width: width * 0.591,
                marginVertical: 10,
              }}
            ></View>

            <View style={{ width: width * 0.591, height: height * 0.546 }}>
              <View
                style={{
                  width: 360,
                  borderRadius: 5,
                  marginVertical: 15,
                }}
              >
                <View
                  style={{
                    width: 360,
                    borderWidth: 0.5,
                    borderRadius: 5,
                    borderColor: "#00237750",
                    marginVertical: 15,
                  }}
                >
                  <Image
                    style={{ width: 360, height: 200 }}
                    source={{ uri: body.image_url[0] }}
                  />
                </View>

                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: "Prompt-Regular",
                    color: "#ccc",
                  }}
                >
                  ควรอัพโหลดรูปภาพขนาด 16:9
                </Text>
              </View>

              <View
                style={{
                  width: width * 0.235,
                  height: height * 0.037,
                  flexDirection: "row",
                }}
              >
                <Text
                  style={{
                    width: width * 0.8,
                    height: height * 0.037,
                    borderTopLeftRadius: 5,
                    borderBottomLeftRadius: 5,
                    borderWidth: 1,
                    overflow: "hidden",
                    borderColor: "#00237740",
                    paddingLeft: 5,
                    fontFamily: "Prompt-Regular",
                    fontSize: 12,
                  }}
                />
                <TouchableOpacity
                  onPress={async () => {
                    const res = await addImage();

                    if (body.image_url[1]) {
                      setBody((val) => ({
                        ...val,
                        image_url: [res, body.image_url[1]],
                      }));
                    } else {
                      setBody((val) => ({ ...val, image_url: [res] }));
                    }
                  }}
                  style={{
                    width: width * 0.05,
                    height: height * 0.037,
                    backgroundColor: "#002377",
                    borderTopRightRadius: 5,
                    borderBottomRightRadius: 5,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: "Prompt-Regular",
                      color: "#ffff",
                      margin: "auto",
                    }}
                  >
                    อัพโหลดรูป
                  </Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width: width * 0.53,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={styles.Boxarea}>
                  <Text style={styles.Text18}>วิดีโอ URL</Text>
                  <TextInput
                    value={body.image_url[1]}
                    onChangeText={(text) => {
                      setBody((val) => ({
                        ...val,
                        image_url: [val.image_url[0], text],
                      }));
                    }}
                    style={styles.TextInput}
                  />
                </View>
                <View style={styles.Boxarea}></View>
              </View>

              <View style={styles.Boxarea}>
                <Text style={styles.Text18}>หัวข้อ</Text>
                <TextInput
                  value={body.name}
                  onChangeText={(text) => {
                    setBody((val) => ({ ...val, name: text }));
                  }}
                  style={styles.TextInput}
                />
              </View>
              <View
                style={{
                  width: width * 0.53,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={styles.Boxarea}>
                  <Text style={styles.Text18}>วันที่</Text>
                  <TouchableOpacity
                    onPress={() => {
                      setModalVisible((val) => !val);
                    }}
                  >
                    <Text style={styles.TextInput}>
                      {moment(body.date).add(543, "years").format("DD/MM/YYYY")}
                    </Text>
                  </TouchableOpacity>
                </View>
                <View onPress={() => { }} style={styles.Boxarea}>
                  <Text style={styles.Text18}>เวลา</Text>
                  <View
                    style={[
                      styles.TextInput,
                      {
                        flexDirection: "row",
                        alignItems: "center",
                        borderWidth: 0,
                      },
                    ]}
                  >
                    <TextInput
                      value={body.starttimehour}
                      placeholder={"00"}
                      onChangeText={(text) => {
                        if (parseInt(text) < 24) {
                          if (text.length < 3) {
                            setBody((val) => ({ ...val, starttimehour: text }));
                          }
                        } else if (text.length == 0) {
                          setBody((val) => ({ ...val, starttimehour: text }));
                        }
                      }}
                      style={[styles.TextInput, { width: height * 0.043 }]}
                    />
                    <Text style={[styles.Text18, { marginHorizontal: 10 }]}>{"ชม."}</Text>
                    <TextInput
                      value={body.starttimeminute}
                      placeholder={"00"}
                      onChangeText={(text) => {
                        if (parseInt(text) < 60) {
                          if (text.length < 3) {
                            setBody((val) => ({
                              ...val,
                              starttimeminute: text,
                            }));
                          }
                        } else if (text.length == 0) {
                          setBody((val) => ({ ...val, starttimeminute: text }));
                        }
                      }}
                      style={[styles.TextInput, { width: height * 0.043 }]}
                    />
                    <Text style={[styles.Text18, { marginHorizontal: 10 }]}>{"นาที"}</Text>
                    <Text style={[styles.Text18, { marginHorizontal: 10 }]}>{"-"}</Text>
                    <TextInput
                      value={body.endtimehour}
                      placeholder={"00"}
                      onChangeText={(text) => {
                        if (parseInt(text) < 24) {
                          if (text.length < 3) {
                            setBody((val) => ({ ...val, endtimehour: text }));
                          }
                        } else if (text.length == 0) {
                          setBody((val) => ({ ...val, endtimehour: text }));
                        }
                      }}
                      style={[styles.TextInput, { width: height * 0.043 }]}
                    />
                    <Text style={[styles.Text18, { marginHorizontal: 10 }]}>{"ชม."}</Text>
                    <TextInput
                      value={body.endtimeminute}
                      placeholder={"00"}
                      onChangeText={(text) => {
                        if (parseInt(text) < 60) {
                          if (text.length < 3) {
                            setBody((val) => ({ ...val, endtimeminute: text }));
                          }
                        } else if (text.length == 0) {
                          setBody((val) => ({ ...val, endtimeminute: text }));
                        }
                      }}
                      style={[styles.TextInput, { width: height * 0.043 }]}
                    />
                    <Text style={[styles.Text18, { marginHorizontal: 10 }]}>{"นาที"}</Text>

                  </View>
                </View>
              </View>
              {/* 
              modalVisible */}

              <View style={{ flexDirection: "row", marginLeft: width * 0.05 }}>
                <View style={[styles.Boxarea, { height: null }]}>
                  {modalVisible == true && (
                    <Calendar
                      onChange={(value) => {
                        setModalVisible(false);
                        setBody((val) => ({ ...val, date: value }));
                      }}
                      value={value}
                    />
                  )}
                </View>
                <View
                  style={[
                    styles.Boxarea,
                    { height: null, marginLeft: width * 0.05 },
                  ]}
                >
                  {/* {modalVisible1 == true && (
                    <Calendar
                      onChange={(value) => {
                        setBody((val) => ({ ...val, date: value }));
                      }}
                      value={value}
                    />
                  )} */}
                </View>
              </View>

              {/* setModalVisible((val) => !val); */}
              <View style={styles.Boxarea}>
                <Text style={styles.Text18}>สถานที่</Text>
                <TextInput
                  value={body.place}
                  onChangeText={(text) => {
                    setBody((val) => ({ ...val, place: text }));
                  }}
                  style={styles.TextInput}
                />
              </View>
              <View style={styles.Boxarea}>
                <Text style={styles.Text18}>วิทยากร</Text>
                <TextInput
                  value={body.create_by}
                  onChangeText={(text) => {
                    setBody((val) => ({ ...val, create_by: text }));
                  }}
                  style={styles.TextInput}
                />
              </View>

              <View
                style={{
                  width: width * 0.43,

                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginVertical: 15,
                }}
              >
                <Text style={[styles.Text18, { alignSelf: "center" }]}>
                  รายละเอียด
                </Text>

                <CKEditor
                  config={{
                    extraPlugins: [uploadPlugin],
                  }}
                  editor={ClassicEditor}
                  data={body.description}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    // console.log("Editor is ready to use!", editor);
                  }}
                  onChange={async (event, editor) => {
                    const data = await editor.getData();
                    setBody((val) => ({
                      ...val,
                      description: data,
                    }));
                    // setDesCom(data);
                  }}
                  onBlur={(event, editor) => {
                    // console.log("Blur.", editor);
                  }}
                  onFocus={(event, editor) => {
                    // console.log("Focus.", editor);
                  }}
                />
              </View>

              <View style={styles.Boxareabutton}>
                <TouchableOpacity
                  onPress={onPress}
                  style={{
                    width: 100,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#69D443",
                    marginRight: 20,
                  }}
                >
                  <Text style={styles.TextButton}>ยืนยัน</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  onPress={() => setpage(1)}
                  style={{
                    width: 100,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#D44343",
                  }}
                >
                  <Text style={styles.TextButton}>ยกเลิก</Text>
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        </View>
      )}
      {page == 1 && <ManageCalendar />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Boxarea: {
    width: width * 0.25,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginVertical: 15,
  },
  Boxareabutton: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 70,
  },
  Text18: { fontSize: 16, fontFamily: "Prompt-Regular" },
  TextInput: {
    width: width * 0.182,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: 16,
    fontFamily: "Prompt-Regular",
  },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});

export default addResearch;
